import { lazyNamed } from 'src/utils/lazyNamed';
import { Advertisers } from './pages/Advertisers';
import { Campaigns } from './pages/Campaigns';
import { Creatives } from './pages/Creatives';

export default {
  Helmet: lazyNamed(() => import('./components/Helmet'), 'Helmet'),
  Campaigns,
  Advertisers,
  Creatives,
};
